"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(base, context) {
    var legend = context.legend, seriesComponents = context.series;
    var itemClickEnabled;
    if (legend) {
        itemClickEnabled = legend.props.itemClickEnabled;
    }
    var pie = seriesComponents &&
        seriesComponents.find(function (individualSeries) {
            return ['pie', 'donut'].includes(individualSeries.props.type);
        });
    var series = base.series, lines = base.lines, areas = base.areas, arearanges = base.arearanges, columns = base.columns, columnranges = base.columnranges, candlesticks = base.candlesticks, animation = base.animation, pies = base.pies, heatmaps = base.heatmaps, scatters = base.scatters, bullets = base.bullets, bars = base.bars;
    if (pie && legend) {
        pies.showInLegend = true;
        pies.dataLabels = { enabled: false };
    }
    else {
        pies.showInLegend = false;
    }
    if (itemClickEnabled === false) {
        series.events = {
            legendItemClick: function (event) {
                event.preventDefault();
            }
        };
        pies.point = {
            events: {
                legendItemClick: function (event) {
                    event.preventDefault();
                }
            }
        };
    }
    else {
        series.events = {};
        pies.point = { events: {} };
    }
    series.animation = animation;
    var options = {
        series: series,
        line: __assign({}, lines),
        spline: __assign({}, lines),
        area: __assign({}, areas),
        areaapline: __assign({}, areas),
        arearange: __assign({}, arearanges),
        areasplinerange: __assign({}, arearanges),
        column: __assign({}, columns),
        columnrange: __assign({}, columnranges),
        candlestick: __assign({}, candlesticks),
        pie: __assign({}, pies),
        heatmap: __assign({}, heatmaps),
        scatter: __assign({}, scatters),
        bullet: __assign({}, bullets),
        bar: __assign({}, bars)
    };
    return options;
}
exports.default = default_1;
//# sourceMappingURL=plotOptions.js.map